export type IsWarrantyAppliedState = boolean;

export const isWarrantyAppliedReducerInitialState: IsWarrantyAppliedState = false;

export enum isWarrantyAppliedActionTypes {
  SET_IS_APPLIED = 'SUMMARY_SET_IS_APPLIED',
}

export interface IsWarrantyAppliedAction {
  type: isWarrantyAppliedActionTypes;
  payload: boolean;
}

const isWarrantyAppliedReducer = (
  state: IsWarrantyAppliedState,
  action: IsWarrantyAppliedAction
): IsWarrantyAppliedState => {
  switch (action.type) {
    case isWarrantyAppliedActionTypes.SET_IS_APPLIED: {
      return action.payload;
    }
    default:
      return state;
  }
};

export default isWarrantyAppliedReducer;
